import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPuzzle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPuzzle"><Path d="M3.75 7.75C3.75 6.09315 5.09315 4.75 6.75 4.75H9.25V4.5C9.25 2.98122 10.4812 1.75 12 1.75C13.5188 1.75 14.75 2.98122 14.75 4.5V4.75H17.25C18.9069 4.75 20.25 6.09315 20.25 7.75V9.25H20C18.4812 9.25 17.25 10.4812 17.25 12C17.25 13.5188 18.4812 14.75 20 14.75H20.25V16.25C20.25 17.9069 18.9069 19.25 17.25 19.25H6.75C5.09315 19.25 3.75 17.9069 3.75 16.25V7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPuzzle;
